import { createContext, useContext } from "react";

// The last thing opened from the view on screen (Days, People, Ideas, Bookings, Updates), marked there
// until another is opened from it (DESIGN.md, "An item opens over the view I'm on"): its row or card lit
// as a selected row on the map's list is, saying so (`aria-current`). Which one it is: kept.ts's
// `markedIn`, given by the trip's page around the view.
export const LastOpened = createContext<string | null>(null);

export function useLastOpened(): string | null {
  return useContext(LastOpened);
}

// What a row opening `id` carries when it's the one: lit, saying so.
export const litProps = (lit: boolean) => (lit ? { "aria-current": "true" as const } : {});
